'use client';

import posthog from 'posthog-js';

function isLocalHostname() {
  if (typeof window === 'undefined') return false;

  const { hostname } = window.location;
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

export const isPostHogEnabled = () =>
  process.env.NEXT_PUBLIC_ENABLE_ANALYTICS === 'true' &&
  Boolean(process.env.NEXT_PUBLIC_POSTHOG_KEY) &&
  !isLocalHostname();

function normalizeProperties(properties?: Record<string, unknown>) {
  if (!properties) return {};

  return Object.fromEntries(Object.entries(properties).filter(([, value]) => value !== undefined));
}

export const captureAnalyticsEvent = (eventName: string, properties?: Record<string, unknown>) => {
  if (typeof window === 'undefined' || !isPostHogEnabled()) return;
  posthog.capture(eventName, normalizeProperties(properties));
};

export default posthog;
